module.exports = "/_next/static/images/loading_11-2571f130954c4b1f1a7ff056a974056c.png";